import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { ShipmentsService } from "../services/shipments.service"
import { AuthService } from '../services/auth.service';
import { server } from '../services/constants'

@Component({
  selector: 'app-invoice-view',
  templateUrl: './invoice-view.component.html',
  styleUrls: ['./invoice-view.component.css']
})
export class InvoiceViewComponent implements OnInit {
  invshipments;
  bol;
  user;
  client;
  isLoggedIn$: Observable<boolean>  
  httpAddress = server

  constructor(private shipmentsService: ShipmentsService, private router: Router, private authService: AuthService ) {
    this.authService.getUserClientPromise2()    
   };

  ngOnInit() { this.onStartup()};

  onStartup() {
    this.isLoggedIn$ = this.authService.isLoggedIn$
    this.authService.user$.subscribe((user:any) => {
      console.log(user)
      this.user = user;
      if(!user.message) {
        if( user.clientid == 0) {
          this.getShipments(user.clientid);
          this.authService.client$.subscribe((client) => {
            console.log(client)
            this.client = client;
          });
        }else { 
          this.authService.client$.subscribe((client) => {
            console.log(client)
            this.client = client;
            if(client.cname != 'No Client Selected' && user.clientid != 0){
              this. getShipments(client.clientid);
              }
            })
        }
      }        
    })
  }

  getShipments(clientid){
    if(localStorage.getItem('selectedId') && clientid == 0){
      let clientId = localStorage.getItem('selectedId');
      this.shipmentsService.getBolInvPod(clientId)
      .then(shipmentsPod => {
        this.invshipments = shipmentsPod
      })
    }else{
      this.shipmentsService.getBolInvPod(clientid)
      .then(shipmentsPod => {
        this.invshipments = shipmentsPod
      })
    };  

  };

  onBolSearch(){
    this.router.navigate(['/editbol/' + this.bol])
  };

  convertDate(date) {
    const dataArray = date.split('-');
    const convDate = dataArray[0] + '/' + dataArray[1] + '/' + dataArray[2];
    return convDate;
         
  }

}



// WEBPACK FOOTER //
// ./src/app/invoice-view/invoice-view.component.ts